import './Markers.css';

export function AirplaneSvgData(width: number, height: number, fillColor: string) {
  return `
    <svg class="idata-target-marker" xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 1450 1450">
   <g fill=${fillColor} style="transform: none;">
      <g style="transform: none;">
         <path id="pjLhTh6VH" d="M631 968 c21 -84 39 -156 39 -160 0 -5 -109 -8 -243 -8 l-243 0 -37 -38 -37 -38 0 -117 0 -117 35 0 c33 0 36 3 75 80 l40 80 205 0 c113 0 205 -3 205 -7 0 -5 -18 -77 -39 -160 l-39 -153 37 0 c35 1 40 6 155 160 l118 160 182 0 c99 0 198 5 218 10 91 26 104 85 25 120 -37 17 -67 20 -233 20 l-192 0 -118 160 c-115 154 -120 159 -155 160 l-37 0 39 -152z"></path>
      </g>
   </g>
</svg>`;
}
